const initialState = {
  windowSize: {
    height: 0,
    width: 0,
  },
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case 'WINDOW_RESIZED':
      return Object.assign({}, state, {
        windowSize: action.windowSize,
      });

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./assets/js/src/reducers/media-lab-card-framework.js
 **/